import { CurrencyEnum } from '../generated/orval/schemas';

const languageCurrencyMap: Record<string, string> = {
  de: 'eur',
  en: 'usd',
  es: 'eur',
  fr: 'eur',
  it: 'eur',
  ja: 'jpy',
  ko: 'krw',
  ms: 'myr',
  nl: 'eur',
  pt: 'brl',
  se: 'sek',
  th: 'thb',
  vi: 'vnd',
  zh: 'cny',
  'zh-Hant': 'twd',
};

export function buildCurrencyOptions(language: string) {
  const baseCurrencies = ['eur', 'gbp', 'sek'];
  const localeCurrency = languageCurrencyMap[language] ?? languageCurrencyMap[language.split('-')[0]];
  const popularCurrencies =
    localeCurrency && !baseCurrencies.includes(localeCurrency)
      ? [localeCurrency, ...baseCurrencies]
      : baseCurrencies;

  return [
    ...popularCurrencies.map((c) => ({ value: c, label: c.toUpperCase() })),
    { value: '__separator__', label: '───', isDisabled: true },
    ...Object.values(CurrencyEnum)
      .filter((c) => !popularCurrencies.includes(c))
      .map((c) => ({ value: c, label: c.toUpperCase() })),
  ];
}
